import { redirect } from "react-router-dom";

const Protected = ({isLogin,children}) => {
  if(!isLogin){
      redirect("/login");
    }
    return children;
}
export default Protected